import { useState } from "react";
import { View, Linking } from "react-native";
import { Row, semanticColors } from "@louise/moon-ui";
import { useTranslations } from "@src/packages/i18n";
import { SupportConversationModal } from "@louise/support/SupportConversationModal";
import { EMBER } from "../../../../onboarding/theme";
import {
  GroupedCard,
  YouIllustration,
  YOU_ILLUSTRATION_SIZE,
} from "../components";

const supportChatIllustration =
  require("@src/apps/moon/assets/images/you-icons/support/chat-row-3d.png") as number;
const supportPrivacyIllustration =
  require("@src/apps/moon/assets/images/you-icons/support/privacy-row-3d.png") as number;
const supportTermsIllustration =
  require("@src/apps/moon/assets/images/you-icons/support/terms-row-3d.png") as number;

export default function Support() {
  const t = useTranslations();
  const [conversationEntryPoint, setConversationEntryPoint] = useState<
    "support" | "feedback" | null
  >(null);

  return (
    <View>
      <GroupedCard>
        <Row
          surface="plain"
          leading={<YouIllustration source={supportChatIllustration} />}
          leadingSize={YOU_ILLUSTRATION_SIZE}
          title={t("you.support.chat_label")}
          onPress={() => setConversationEntryPoint("support")}
          action="you.support.chat_label"
          borderRadius={0}
          paddingHorizontal={16}
          paddingVertical={11}
          style={{ borderRadius: 0 }}
          titleStyle={{
            fontSize: 15,
            lineHeight: 18,
            fontWeight: "500",
            color: EMBER.colors.text,
          }}
        />
        <Row
          surface="plain"
          leading={<YouIllustration source={supportChatIllustration} />}
          leadingSize={YOU_ILLUSTRATION_SIZE}
          title={t("you.support.feedback_label")}
          onPress={() => setConversationEntryPoint("feedback")}
          action="you.support.feedback_label"
          borderRadius={0}
          paddingHorizontal={16}
          paddingVertical={11}
          style={{
            borderRadius: 0,
            borderTopWidth: 1,
            borderTopColor: semanticColors.border.strong,
          }}
          titleStyle={{
            fontSize: 15,
            lineHeight: 18,
            fontWeight: "500",
            color: EMBER.colors.text,
          }}
        />
        <Row
          surface="plain"
          leading={<YouIllustration source={supportPrivacyIllustration} />}
          leadingSize={YOU_ILLUSTRATION_SIZE}
          title={t("you.support.privacy_label")}
          onPress={() => Linking.openURL("https://louise.life/privacy")}
          action="you.support.privacy_label"
          borderRadius={0}
          paddingHorizontal={16}
          paddingVertical={11}
          style={{
            borderRadius: 0,
            borderTopWidth: 1,
            borderTopColor: semanticColors.border.strong,
          }}
          titleStyle={{
            fontSize: 15,
            lineHeight: 18,
            fontWeight: "500",
            color: EMBER.colors.text,
          }}
        />
        <Row
          surface="plain"
          leading={<YouIllustration source={supportTermsIllustration} />}
          leadingSize={YOU_ILLUSTRATION_SIZE}
          title={t("you.support.terms_label")}
          onPress={() => Linking.openURL("https://louise.life/legal")}
          action="you.support.terms_label"
          borderRadius={0}
          paddingHorizontal={16}
          paddingVertical={11}
          style={{
            borderRadius: 0,
            borderTopWidth: 1,
            borderTopColor: semanticColors.border.strong,
          }}
          titleStyle={{
            fontSize: 15,
            lineHeight: 18,
            fontWeight: "500",
            color: EMBER.colors.text,
          }}
        />
      </GroupedCard>

      <SupportConversationModal
        visible={conversationEntryPoint !== null}
        entryPoint={conversationEntryPoint ?? "support"}
        onClose={() => setConversationEntryPoint(null)}
      />
    </View>
  );
}
